import styled from 'styled-components';

const TemplateVideoSliderWithInfoWrapper = styled.div`
  max-height: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 100%;
  height: 100%;
  background-color: #fff;
  pointer-events: all;
`;

export const InfoAndButtonsWrapper = styled.div`
  padding: 50px 20px 30px;
`;

export default TemplateVideoSliderWithInfoWrapper;
